import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, IconButton, Pagination, Stack, Typography, useTheme, } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import { isNotEmpty } from '../../../utils/format';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import SearchTxtField from '../../../components/SearchTxtField';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert } from '../../../components/notify';
import CatCard from '../../../components/CatCard';
import ProductCard from '../../../components/ProductCard';
import constants from '../../../utils/Constants';
import { Add } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import route from '../../../utils/Routes';
import { getComCatServ, getComProdServ } from '../../../services/com-service';



function ComCatList({ aComId, type = 'amtc' }) {
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const theme = useTheme();
    const limit = 12;
    const [searchParams, setSearchParams] = useSearchParams();
    const prPageNumber = parseInt(searchParams.get("prPageNumber") || "1");
    const caPageNumber = parseInt(searchParams.get("caPageNumber") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const [caOrder, setCaOrder] = useState('desc');
    const comId = type === 'amtc' ? aComId : ctxtUser?.comId;

    const { isLoading: isCatLoading, isError: isCatErr, error: catErr, data: catData } = useQuery([QueryKey.comCatList, comId, limit, caPageNumber, caOrder],
        () => getComCatServ({ comId, limit, pageNumber: caPageNumber, order: caOrder }), {
        enabled: isNotEmpty(comId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.comProd, comId, limit, prPageNumber, isSrchBtnClick],
        () => getComProdServ({ comId, limit, pageNumber: prPageNumber, searchKeyWord: searchWord }), {
        enabled: (isSrchRes === 1 && isNotEmpty(comId)),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isCatLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatLoading]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);


    async function onOrderChange(e) {
        if (caOrder === "desc")
            setCaOrder("asc");
        else
            setCaOrder("desc");
        setSearchParams(prev => {
            prev.set("caPageNumber", 1)
            return prev
        }, { replace: true })
    }


    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    function handleAddProdClick() {
        navigate(route.aAddprodtocatalog, { state: { comId } })
    }

    function handleCatCardClick(i) {
        if (type === 'amtc')
            navigate(`${route.aComSubcategory}/?catId=${i?.id}&catName=${i?.catName}&comId=${comId}`)
        else
            navigate(`${route.cSubCatList}/?catId=${i?.id}&catName=${i?.catName}`)
    }

    const handlePrPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("prPageNumber", value)
            return prev
        }, { replace: true })
    };

    const handleCaPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("caPageNumber", value)
            return prev
        }, { replace: true })
    };



    if (isCatErr) {
        customAlert(catErr);
        return <h2>Something went wrong</h2>
    }

    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={type === 'amtc' ? "87%" : "100%"} width={"100%"} px={type === 'amtc' ? 2 : 0}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Stack width={"33%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}> {isSrchRes === 1 ? "Product List" : "Product Categories"}</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <Box mb={0.5}><SearchTxtField width={400} handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                        onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer`} />
                    </Box>
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {ctxtUser?.userType === constants.admin && <Button variant='outlined' startIcon={<Add />} onClick={handleAddProdClick} sx={{
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Add Product</Button>}
                    {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                        <SwapVertOutlinedIcon />
                    </IconButton>}
                </Stack>
            </Stack>

            {isSrchRes === 1 ? <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i, index) => <Grid item xs="auto" key={`_${index}`}>
                        <ProductCard i={i} isComUser={ctxtUser?.isComUser} type='com' comId={comId} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary" page={prPageNumber} onChange={handlePrPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </> : <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(catData?.catsArr ?? []).map((i, index) => <Grid item xs="auto" key={index}>
                        <CatCard i={i} handleClick={handleCatCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(catData?.totalCatCount / limit) || 0} color="primary" page={caPageNumber} onChange={handleCaPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </>}
        </Box>
    )
}
export default ComCatList;